
import { mapGetters } from "vuex";
import {
  SELECT_EMPRESA,
  UPDATE_EMPRESA_PADRAO,
} from "@/core/services/store/auth.module";

export default {
  name: "EmpresaSelector",
  data() {
    return {
      trocando: false,
      salvandoPadrao: false,
    };
  },
  computed: {
    ...mapGetters(["empresas", "empresaContexto", "empresaPadraoId"]),
    empresaAtualId() {
      return Number(this.empresaContexto?.id_empresa || 0);
    },
    empresaAtual() {
      return (
        this.empresas.find((empresa) => this.isEmpresaAtual(empresa)) || null
      );
    },
    empresaAtualNome() {
      return this.empresaAtual
        ? this.nomeEmpresa(this.empresaAtual)
        : "Selecionar";
    },
  },
  methods: {
    nomeEmpresa(empresa) {
      return (
        empresa?.nome_fantasia ||
        empresa?.nome ||
        `Empresa ${empresa?.id_empresa}`
      );
    },
    tipoEmpresa(empresa) {
      return empresa?.tipo_grupo === "MATRIZ" ? "Matriz" : "Filial";
    },
    isEmpresaAtual(empresa) {
      return Number(empresa?.id_empresa) === this.empresaAtualId;
    },
    isEmpresaPadrao(empresa) {
      return Number(empresa?.id_empresa) === Number(this.empresaPadraoId || 0);
    },
    async definirEmpresaPadrao(empresa) {
      if (this.salvandoPadrao || this.isEmpresaPadrao(empresa)) return;

      this.salvandoPadrao = true;

      try {
        await this.$store.dispatch(UPDATE_EMPRESA_PADRAO, {
          id_empresa: Number(empresa.id_empresa),
        });
        this.$toast.success(
          `${this.nomeEmpresa(empresa)} definida como empresa padrão.`
        );
      } finally {
        this.salvandoPadrao = false;
      }
    },
    async selecionarEmpresa(empresa) {
      if (this.trocando || this.isEmpresaAtual(empresa)) return;

      this.trocando = true;

      try {
        await this.$store.dispatch(SELECT_EMPRESA, {
          id_empresa: Number(empresa.id_empresa),
        });
        this.$toast.success(
          `Empresa alterada para ${this.nomeEmpresa(empresa)}.`
        );
        window.location.reload();
      } finally {
        this.trocando = false;
      }
    },
  },
};
